import appboy from '@braze/web-sdk';
import { setProperties } from '@alltrails/analytics/amplitudeHelpers';
import '../../assets/javascripts/datadome';
import Bugsnag from '@bugsnag/js';

// see https://help.branch.io/developers-hub/docs/web-basic-integration#initialize-branch
(function (b, r, a, n, c, h, _, s, d, k) {
  if (!b[n] || !b[n]._q) {
    for (; s < _.length; ) c(h, _[s++]);
    d = r.createElement(a);
    d.async = 1;
    d.src = 'https://cdn.branch.io/branch-latest.min.js';
    k = r.getElementsByTagName(a)[0];
    k.parentNode.insertBefore(d, k);
    b[n] = h;
  }
})(
  window,
  document,
  'script',
  'branch',
  function (b, r) {
    b[r] = function () {
      b._q.push([r, arguments]);
    };
  },
  { _q: [], _v: 1 },
  'addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking'.split(
    ' '
  ),
  0
);

const store = global.__AT_STORE__;

if (store) {
  if (store.BRAZE_KEY) {
    appboy.initialize(store.BRAZE_KEY, { baseUrl: 'https://sdk.iad-03.braze.com/api/v3' });

    if (store.user) {
      appboy.changeUser(store.user.id);
    }

    if (store.featureFlags.communityFeatureFlag) {
      appboy.getUser()?.setCustomUserAttribute('is_community_beta_enabled', true);
    }

    appboy.openSession();
  }

  if (store.user) {
    setProperties({ is_community_beta_enabled: store.featureFlags?.communityFeatureFlag });
  }

  // Bugsnag.start() will be called in all Rails server environments as long as NODE_ENV is set for production.
  if (process.env.NODE_ENV === 'production') {
    Bugsnag.start({
      apiKey: store.BUGSNAG_KEY,
      appVersion: store.BUILD_DATE,
      releaseStage: store.RAILS_ENV,
    });
  }

  branch.init(store.BRANCH_KEY);
}

// see https://github.com/aFarkas/lazysizes#user-content-js-api---options
window.lazySizesConfig = {
  expand: 10 // size buffer to start loading images before they reach viewport
};

// add simple support for background images:
document.addEventListener('lazybeforeunveil', function lazybeforeunveil(e) {
  let bg = e.target.getAttribute('data-bg');
  if (bg) {
    if (bg.indexOf('url') < 0) {
      bg = `url('${bg}')`;
    }
    if (bg.slice(-1) == ')') {
      // if last character is ')' assume that we're just updated background image
      e.target.style.backgroundImage = bg;
    } else {
      // otherwise, update the entire background css
      e.target.style.background = bg;
    }
  }
});

import('lazysizes');
